<template>
    <div :id="rootElementId" :style="`height:${PITCH_HEIGHT}px`"></div>
</template>

<script>
import { getDataUrl, getNeutralColors } from '../../utils/functions';
import { loadFonts, copyAndAppendElement } from '../../utils/exportToPNG';
import ResizeObserver from 'resize-observer-polyfill';
import UserService from '../../services/user.service';
import * as d3v4 from "d3v4";

  export default {
    name: 'CrossingChart',
    props: {
      id:{
        type: String,
        required: true
      },
      size: {
        type: Number,
        required: false,
      },
      margin: {
        type: Object,
        required: false,
      },
      circlesAndBoxes: {
        type: Array,
        required: false
      },
      allSuccessModel: {
        type: String,
        required: "all"
      },
      mediaMode: {
        type: Boolean,
        default: false
      },
      crossings: {
        type: Array,
        default: () => {
          return []
        }
      },
      areas: {
        type: Array,
        default: () => {
          return []
        }
      },
      allAreas: {
        type: Array,
        default: () => {
          return []
        }
      },
      legendTitle:{
        type:String,
        default: ""
      },
      legendSubtitle:{
        type:String,
        default: ""
      },
      fromTo:{
        type:String,
        default: "from"
      }
    },
    data() {
      return {
        height: 0,
        width: 0,
        images: {}
      }
    },
    computed: {
      SVG_WIDTH(){
        return this.size ? this.size : 380;
      },
      PITCH_WIDTH(){
        if(this.margin){
          return this.SVG_WIDTH - this.margin.left - this.margin.right
        }else{
          return this.SVG_WIDTH;
        }
      },
      PITCH_HEIGHT() {
        return this.PITCH_WIDTH * 0.755
      },
      rootElementId(){
        return `pitchCrossing${this.id}`
      },
      currentUserFieldColor() {
        return this.$store.getters["auth/fieldColor"];
      }
    },
    async mounted() {
      this.observer = new ResizeObserver(this.onResize).observe(document.getElementById(this.rootElementId));

      const SVG_WIDTH = this.size ? this.size : 380;
      const margin = this.margin ? this.margin : {top: 0, right: 0, bottom: 0, left: 0};

      const PITCH_WIDTH = this.PITCH_WIDTH;
      const PITCH_HEIGHT = this.PITCH_HEIGHT;

      d3.selectAll('.tooltip').remove();

      const tooltip = d3
        .select("body")
        .append("div")
        .attr("class", "tooltip no-arrow");

      var svg = d3.select(`#${this.rootElementId}`)
        .append("svg")
        .attr("width", SVG_WIDTH)
        .attr("height", PITCH_HEIGHT)
        .style("background-color", "#ffffff")
        .attr("class", "pitch")
        .attr("id", `${this.rootElementId}SVG`);

      // DRAW PITCH
      this.drawImageBase64(svg, margin.left, margin.top, PITCH_WIDTH, PITCH_HEIGHT, require(`@/assets/img/${this.type === "game" ? "": "half_"}pitch_${this.currentUserFieldColor}.png`),'pitch',true);

      let logo  = require(`@/assets/img/driblab${this.mediaMode ? "_normal" : ""}_${this.currentUserFieldColor === 'white' ? 'color' : 'white'}.png`);
      await this.drawImageBase64(svg, PITCH_WIDTH * 0.735 + margin.left , this.type === "game" ? PITCH_HEIGHT * 0.77 + margin.top : PITCH_HEIGHT * 0.785 + margin.top, PITCH_WIDTH * 0.18, PITCH_HEIGHT * 0.18, logo,'logo');

      if (this.allSuccessModel !== "all") {
        this.crossings = this.crossings.filter(c => this.allSuccessModel === "success" ? c.o : !c.o)
      }

      if (this.circlesAndBoxes && this.circlesAndBoxes.includes("boxes")){
        this.renderBoxes(svg)
      }

      if (this.circlesAndBoxes && this.circlesAndBoxes.includes("circles")){
        // this.renderCrossSegments(svg);
        this.renderCrossCircles(svg);
      }

      if (this.circlesAndBoxes && this.circlesAndBoxes.includes("lines")){
        this.renderCrossSegments(svg);
      }

      this.renderLegend(svg);

      let font = await loadFonts();
      copyAndAppendElement(svg.node(),font.node(),0,0);
    },
    methods: {
      onResize(){
        let elto =document.getElementById(this.rootElementId);
        if(elto){
          this.$emit("sizeChange", {height:elto.clientHeight,width:elto.clientWidth});
        }
      },
      async drawImageBase64(svg,x,y,width,height,img,idName,bottom = false) {
        return new Promise((resolve) => {
          if(!this.images[idName]){
            let base_image = new Image();
            base_image.crossOrigin = "anonymous";
            base_image.src = img;
            base_image.onload = async (event) => {
              const dataUrl = await getDataUrl(event.currentTarget);
              this.drawImage(
              svg,
              x,
              y,
              width,
              height,
              dataUrl,
              idName,
              bottom
              );
              resolve(true);
            }
          }else{
            if(bottom){
              svg.node().insertBefore(this.images[idName],svg.node().firstChild);
            }else{
              svg.node().appendChild(this.images[idName]);
            }
            resolve(true);
          }
        })
      },
      drawImage: function(svg, x, y, width, height, img,idName,bottom = false) {
        let imgNode = bottom ? svg.insert("svg:image",':first-child') : svg.append("svg:image");
          imgNode.attr("x", x)
          .attr("y", y)
          .attr("width", width)
          .attr("height", height)
          .attr("xlink:href", img);
        this.images[idName] = imgNode.node().cloneNode(true);
      },
      renderBoxes(svg) {
        let textColor = this.currentUserFieldColor === 'white' ? 'black' : 'white';

        const shotLegend = this.$t("team.crossings").toLowerCase();

        var shadowScale = d3.scale.linear().domain([0, this.crossings.length]).range([0.1, 1.2]);

        let areasTarget = this.fromTo === 'from' ? this.areas : this.allAreas;
        _.forEach(areasTarget,(a,i) => {
          let areaCrossings = _.filter(this.crossings,(c) => {
            let targetCoord = this.fromTo === 'from' ? [c.x,c.y] : [c.x_end,c.y_end]
            let areaContainCross = ((100 - targetCoord[0]) >= a.xStart && (100 - targetCoord[0]) <= a.xEnd) && ((100 - targetCoord[1]) >= a.yStart && (100 - targetCoord[1]) <= a.yEnd)
            return areaContainCross
          })
          if(areaCrossings.length){
            this.drawRectangle(svg,
              a.xStartRect * this.SVG_WIDTH,
              a.yStartRect * this.PITCH_HEIGHT,
              a.xEndRect * this.SVG_WIDTH,
              a.yEndRect * this.PITCH_HEIGHT, "red", shadowScale(areaCrossings.length),`crossArea-${i}`);
            let pct = ((areaCrossings.length / this.crossings.length) * 100).toFixed(1)
            let centerX = ((a.xEndRect * this.SVG_WIDTH) / 2) + (a.xStartRect * this.SVG_WIDTH);
            let centerY = ((a.yEndRect * this.PITCH_HEIGHT) / 2) + (a.yStartRect * this.PITCH_HEIGHT);
            let successfulCrossings = _.filter(areaCrossings,(c) => c.o);
            this.writeText(svg, centerX , centerY - (0.03 * this.PITCH_HEIGHT) , "middle", (0.018 * this.SVG_WIDTH) + "px", `${ pct } %`,textColor);
            if (this.allSuccessModel === "all") {
              this.writeText(svg, centerX , centerY, "middle", (0.018 * this.SVG_WIDTH) + "px", `${ successfulCrossings.length }/${ areaCrossings.length }`,textColor);
              this.writeText(svg, centerX , centerY + (0.03 * this.PITCH_HEIGHT), "middle", (0.012 * this.SVG_WIDTH) + "px", `${ ((successfulCrossings.length / areaCrossings.length) * 100).toFixed(1)  }% ${this.$t("game.gamePossessionMap.of")} ${this.$t("general.accuracy")}`,textColor);
            }
          }
        })
      },
      drawRectangle(svg, x, y, width, height, color, opacity, className) {
        return svg.append("rect")
          .attr("class", className)
          .attr("x", x)
          .attr("y", y)
          .attr("width", width)
          .attr("height", height)
          .style("fill", color)
          .style("opacity", opacity);
      },
      writeText(svg, x, y, anchor, fontSize, text, fill = "white", className = "none") {
        svg.append("text")
          .attr("x", x)
          .attr("y", y)
          .attr("text-anchor", anchor)
          .attr("dy", "0.8em")
          .attr("font-weight", 500)
          .attr("class", className)
          .style("font-size", fontSize)
          .style("font-family", "NeueMontreal")
          .style("fill", fill)
          .text(text);
      },
      renderCrossSegments(svg) {

        let x = d3.scale.linear().domain([0 - (100 * 0.093), 100 + (100 * 0.1)]).range([this.PITCH_WIDTH, 0]);
        let y = d3.scale.linear().domain([0 - (100 * 0.105), 100 + (100 * 0.105)]).range([this.PITCH_HEIGHT, 0]);

        let radius = d3.scale.linear().domain([0, 1]).range([this.PITCH_WIDTH * 0.0055, this.PITCH_HEIGHT * 0.024]);

        // ====================================================================
        //        Render Segments
        // ====================================================================
        for (let segment of this.crossings) {
          let sx0 = x(segment.y);
          let sy0 = y(100 - (100 - segment.x) * 2);
          let sx1 = x(segment.y_end);
          let sy1 = y(2 * segment.x_end - 100);
          this.drawCrossLine(svg, sx0, sy0, sx1, sy1, segment.o);
        }
      },
      drawCrossLine(svg, x0, y0, x1, y1, outcome) {
        var self = this;
        let line = svg.append("line")
          .attr("x1", x0)
          .attr("y1", y0)
          .attr("x2", x1)
          .attr("y2", y1)
          .attr("stroke-width", 1.5)
          .style("opacity", 1)
          .attr("stroke", outcome ? '#28e628' : "#FF0000")
          .attr("id",`cross-line`)

        if(outcome){
          svg.append("circle")
          .attr("r", this.PITCH_WIDTH * 0.0065)
          .attr("cx", x1)
          .attr("cy", y1)
          .style("fill-opacity", 0.925)
          .style("opacity", 1)
          .style("stroke",  '#28e628')
          .style("stroke-width", 2)
          .style("fill", '#28e628')
          .attr("id", "dot-cross-line");
        }else{
          svg.append('path')
          .attr("d", d3.svg.symbol().type('cross').size(this.size * 0.15))
          .attr('stroke', "#FF0000")
          .attr('fill', "#FF0000")
          .attr('stroke-width', 0.1)
          .attr("transform", (d) => { return "translate(" + x1 + "," + y1 + ") rotate(-45)"; })
          .attr("id", "fail-cross-line");
        }
      },
      drawCrossCircle(svg,  x, y, circle, i) {
        let xRange = d3.scale.linear().domain([0 - (100 * 0.093), 100 + (100 * 0.1)]).range([this.PITCH_WIDTH, 0]);
        let yRange = d3.scale.linear().domain([0 - (100 * 0.105), 100 + (100 * 0.105)]).range([this.PITCH_HEIGHT, 0]);

        var self = this;
        let r = this.PITCH_WIDTH * 0.005
        svg.append("circle")
          .attr("r", r)
          .attr("cx", x)
          .attr("cy", y)
          .attr('id', "cross" + i)
          .style("fill-opacity", 0.6)
          .style("opacity", 0.8)
          .style("stroke",  circle.o ? '#28e628' : "#FF0000" )
          .style("stroke-width", 2)
          .style("fill", circle.o ? '#28e628' : "#FF0000")
          .on('mouseenter',(d) => {
            let sx0 = this.fromTo === 'from' ? xRange(circle.y) : xRange(circle.y_end);
            let sy0 = this.fromTo === 'from' ? yRange(100 - (100 - circle.x) * 2) : yRange(2 * circle.x_end - 100);;
            let sx1 = this.fromTo === 'from' ? xRange(circle.y_end) : xRange(circle.y);
            let sy1 = this.fromTo === 'from' ? yRange(2 * circle.x_end - 100) : yRange(100 - (100 - circle.x) * 2);
            if (!self.circlesAndBoxes || !self.circlesAndBoxes.includes("lines")){
              self.drawCrossLine(svg, sx0, sy0, sx1, sy1, circle.o);
            }

            let tooltipText= `
              <div style="display:flex;flex-direction:column;padding:5px; 15px;">
                <span style="font-weight:bold;">${circle.pN}</span>
                <span>${circle.gN}</span>
                <span style="font-size:11px;">@ ${circle.min}:${circle.sec}</span>
              </div>
            `
            let crossCircle = d3.select(`#cross${i}`).node();
            d3.select("body > .tooltip")
              .style("top", crossCircle.getBoundingClientRect().top + window.scrollY + r + 15 + "px")
              .style("height","auto")
              .style("width","auto")
              .style("display", "inline-block")
              .style("left", () => {
                return `${crossCircle.getBoundingClientRect().left + r - (d3.select("body > .tooltip").node().getBoundingClientRect().width / 2)}px`
              })
              .style("font-size", "14px")
              .html(tooltipText);
          })
          .on('mouseout',function() {
            if (!self.circlesAndBoxes || !self.circlesAndBoxes.includes("lines")){
              d3.select("body > .tooltip").style("display", "none");
              d3.select("#cross-line").remove();
              d3.select("#fail-cross-line").remove();
              d3.select("#dot-cross-line").remove();
            }
          });
      },
      renderCrossCircles(svg) {

        let x = d3.scale.linear().domain([0 - (100 * 0.093), 100 + (100 * 0.1)]).range([this.PITCH_WIDTH, 0]);
        let y = d3.scale.linear().domain([0 - (100 * 0.105), 100 + (100 * 0.105)]).range([this.PITCH_HEIGHT, 0]);

        let radius = d3.scale.linear().domain([0, 1]).range([this.PITCH_WIDTH * 0.0055, this.PITCH_WIDTH * 0.024]);
        for (let i in this.crossings) {
          let sx = this.fromTo === 'from' ? x(this.crossings[i].y) : x(this.crossings[i].y_end);
          let sy = this.fromTo === 'from' ? y(2 * this.crossings[i].x - 100) : y(2 * this.crossings[i].x_end - 100);
          this.drawCrossCircle(svg,sx,sy, this.crossings[i], i);
        }
      },
      renderLegend(svg){
        let textColor = this.currentUserFieldColor === 'white' ? 'black' : 'white';
        this.writeText(svg, 0.0875 * this.PITCH_WIDTH , 0.0375 * this.PITCH_HEIGHT, "start", (0.016 * this.SVG_WIDTH) + "px",
        `${ this.legendTitle }`,textColor);
        this.writeText(svg, 0.0875 * this.PITCH_WIDTH , 0.0675 * this.PITCH_HEIGHT, "start", (0.014 * this.SVG_WIDTH) + "px",
        `${ this.legendSubtitle }`,textColor);

        this.writeText(svg, 0.92 * this.PITCH_WIDTH , 0.0375 * this.PITCH_HEIGHT, "end", (0.016 * this.SVG_WIDTH) + "px",
        `${ this.crossings.length } ${this.$t("team.crossings")}`,textColor);
        if (this.allSuccessModel === "all") {
          this.writeText(svg, 0.92 * this.PITCH_WIDTH , 0.0675 * this.PITCH_HEIGHT, "end", (0.014 * this.SVG_WIDTH) + "px",
          `${ _.filter(this.crossings,(c) => c.o).length } ${this.$t("eventChart.successful")}`,textColor);
        }
      }
    },
    destroyed() {
      delete this.observer;
    },
  }

</script>



// WEBPACK FOOTER //
// src/views/base/CrossingChart.vue